import { set, get } from 'lodash-es';
import { Storage } from 'site-modules/shared/utils/storage';

export const PRIVATE_LISTING_PATH = 'privateListing';

export const PrivateListingStorage = {
  /**
   * Returns session storage instance
   * @returns {Storage}
   */
  getSessionStorage() {
    if (!this.sessionStorage) this.sessionStorage = new Storage('sessionStorage');
    return this.sessionStorage;
  },

  /**
   * Sets value to storage by path
   * @param {Storage} storage
   * @param {String} path
   * @param value
   */
  setValue(storage, path, value) {
    const privateListingStorage = storage.get(PRIVATE_LISTING_PATH) || {};
    set(privateListingStorage, path, value);
    storage.set(PRIVATE_LISTING_PATH, privateListingStorage);
  },

  /**
   * Returns value from storage by path
   * @param {Storage} storage
   * @param {String} path
   * @returns value form storage
   */
  getValue(storage, path) {
    const privateListingStorage = storage.get(PRIVATE_LISTING_PATH) || {};
    return get(privateListingStorage, path);
  },

  /**
   * Sets value to session storage by path
   * @param {String} path
   * @param value
   */
  setValueToSessionStorage(path, value) {
    this.setValue(this.getSessionStorage(), path, value);
  },

  /**
   * Returns value from session storage by path
   * @param {String} path
   * @returns value from session storage
   */
  getValueFromSessionStorage(path) {
    return this.getValue(this.getSessionStorage(), path);
  },
};
